import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetContractOrigins } from '@/graphql/contracts/_generated_/getContractOrigins.query';
import getContractOriginsQuery from '@/graphql/contracts/getContractOrigins.query.gql';

export function getContractOrigins(): ContractOrigin[] {
  const result = apolloClientContracts.readQuery<GetContractOrigins>({
    query: getContractOriginsQuery
  });

  return result?.contractOrigins || [];
}
